<astral-accordion [header]="'PROPERTY_TAX.HEADER'">
  @if (form) {
    <div class="astral-stack-l" [formGroup]="form">
      <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
        <astral-select [control]="form.controls['selectedTaxAssessmentYear']" [itemsSource]="yearSelection"></astral-select>
        <div class="astral-form-adjacent-action">
          <astral-button
            variant="primary"
            size="small"
            type="button"
            icon="plus"
            labelKey="PROPERTY_TAX.ADD_ASSESSMENT_UNIT"
            (click)="startAddAssessmentUnit()"
          ></astral-button>
        </div>
      </astral-layout-group>
      <div formArrayName="propertyTaxForms" class="astral-accordion-stack">
        @for (index of propertyTaxIndicesExisting; track index) {
          <astral-accordion [header]="getPropertyTaxHeaderByIndex(index)" [translateHeader]="false">
            <div [formGroupName]="index" class="astral-stack-l">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [control]="form.controls['propertyName']" [helpText]="'PROPERTYNAME'"></astral-input>
                <astral-select
                  [control]="propertyTaxForms.at(index).get('assessmentUnitTypeCode')"
                  [itemsSource]="getTypeCodeSelectionForIndex(index)"
                ></astral-select>
                <astral-date-picker [control]="propertyTaxForms.at(index).get('decisionDate')"></astral-date-picker>
                <div class="astral-form-adjacent-action">
                  <astral-button
                    variant="secondary"
                    size="small"
                    type="button"
                    icon="trash"
                    labelKey="DELETE_BTN"
                    (click)="removeAssessmentUnit(index)"
                  ></astral-button>
                </div>
              </astral-layout-group>
              <app-building-property-tax-assessment
                [buildings]="buildings"
                [propertyTaxIds]="[propertyTaxForms.at(index).get('id')?.value]"
                (assessmentsChange)="onAssessmentsChange(index, $event)"
                [buildingPropertyTaxAssessments]="getBuildingAssessments(index)"
                [disabledBuildingIds]="getDisabledBuildingIds(index)"
              ></app-building-property-tax-assessment>
              <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
                <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
                  <astral-input [control]="propertyTaxForms.at(index).get('typeCodeBuildingSum')"></astral-input>
                  <astral-input [control]="propertyTaxForms.at(index).get('typeCodeLandSum')"></astral-input>
                  <astral-input [control]="propertyTaxForms.at(index).get('typeCodeTotalSum')"></astral-input>
                </astral-layout-group>
              </section>
            </div>
          </astral-accordion>
        }
        @for (index of propertyTaxIndicesNew; track index) {
          <astral-accordion [header]="getPropertyTaxHeaderByIndex(index)" [translateHeader]="false">
            <div [formGroupName]="index" class="astral-stack-l">
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input [control]="form.controls['propertyName']" [helpText]="'PROPERTYNAME'"></astral-input>
                <astral-select
                  [control]="propertyTaxForms.at(index).get('assessmentUnitTypeCode')"
                  [itemsSource]="getTypeCodeSelectionForIndex(index)"
                ></astral-select>
                <astral-date-picker [control]="propertyTaxForms.at(index).get('decisionDate')"></astral-date-picker>
                <div class="astral-form-adjacent-action">
                  <astral-button
                    variant="secondary"
                    size="small"
                    type="button"
                    icon="trash"
                    labelKey="DELETE_BTN"
                    (click)="removeAssessmentUnit(index)"
                  ></astral-button>
                </div>
              </astral-layout-group>
              <app-building-property-tax-assessment
                [buildings]="buildings"
                [propertyTaxIds]="[propertyTaxForms.at(index).get('id')?.value]"
                (assessmentsChange)="onAssessmentsChange(index, $event)"
                [buildingPropertyTaxAssessments]="getBuildingAssessments(index)"
                [disabledBuildingIds]="getDisabledBuildingIds(index)"
              ></app-building-property-tax-assessment>
            </div>
          </astral-accordion>
        }
      </div>
      <section class="astral-section-surface astral-stack-l">
        <h5>{{ 'PROPERTY_TAX.TOTAL_SUM_HEADER' | translate }}</h5>
        <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['propertyTaxBuildingSum']"></astral-input>
          <astral-input [control]="form.controls['propertyTaxLandSum']"></astral-input>
          <astral-input [control]="form.controls['propertyTaxTotalSum']"></astral-input>
          <astral-input [control]="form.controls['propertyTaxTaxablePremisesSum']"></astral-input>
          <astral-input [control]="form.controls['propertyTaxTaxableLandSum']"></astral-input>
          <astral-input [control]="form.controls['propertyTaxTaxableSum']"></astral-input>
        </astral-layout-group>
      </section>
    </div>
  }
</astral-accordion>
